import { Box, Typography } from "~/components/UI";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import GraphicGridContainer from "./GraphicGridContainer";
import { ANIMATION_DURATION, timeTickFormatter, dateFormatter } from "./Common";

interface InvoiceDurationProps {
  period?: MetricsAPI.eTimePeriod;
  list?: MetricsAPI.MetricDataDto;
  yAxis?: string;
}

const TooltipContent = ({
  time,
  duration,
}: {
  time: string;
  duration: number;
}) => {
  const { t } = useTranslation();
  return (
    <Box border={1} borderColor="divider" p={3} bgcolor="background.paper">
      <Typography gutterBottom>
        <strong>{t("label.time")}:</strong> {time}
      </Typography>
      <Typography>
        <strong>{t("label.duration")}:</strong> {timeTickFormatter(duration)}
      </Typography>
    </Box>
  );
};

const InvoiceDuration = ({ period, list, yAxis }: InvoiceDurationProps) => {
  return (
    <GraphicGridContainer yAxis={yAxis}>
      <BarChart data={list as any}>
        <CartesianGrid vertical={false} strokeDasharray="2" />
        <XAxis
          dataKey="createdAt"
          domain={["auto", "auto"]}
          tickCount={0}
          tickLine={false}
          axisLine={false}
          tickFormatter={dateFormatter(period)}
        />
        <YAxis
          type="number"
          dataKey="average"
          allowDecimals={false}
          domain={[0, "auto"]}
          tickLine={false}
          axisLine={false}
          width={45}
          tickFormatter={timeTickFormatter}
        />
        <Tooltip
          content={({ active, payload, label }: any) => {
            return active && payload && payload.length ? (
              <TooltipContent
                time={dateFormatter(period)(label)}
                duration={payload[0].value}
              />
            ) : null;
          }}
        />
        <Bar
          dataKey="average"
          fill="#D9F3DB"
          animationDuration={ANIMATION_DURATION}
        />
      </BarChart>
    </GraphicGridContainer>
  );
};

export default InvoiceDuration;
